import PdpLayout from "@/components/pdp/PdpLayout";
import { EYE_REPAIR_V3 } from "@/data/eyeRepairV3";

export default function PdpConceptV3() {
  return <PdpLayout data={EYE_REPAIR_V3} />;
}
